import React from "react";
import { connect } from "react-redux";
import * as actions from "MODULES/RepairOrders/actions";
import { form, Form as AppForm } from "MODULES/shared/components/Forms";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import PaymentTerms from "MODULES/shared/components/PaymentTerms/PaymentTerms";

const formName = "editROBilling";

export function Form(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow>
          <Col md={6}>
            <PaymentTerms getInitialFieldValue={props.getInitialFieldValue} />
          </Col>
        </FormRow>
      </AppForm.Body>
    </AppForm>
  );
}

export default connect(undefined, { onSubmit: actions.update })(
  form({
    form: formName
  })(withFieldAccessors(Form))
);



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Edit/BillingForm.jsx